import React, { useEffect, useMemo, useState } from 'react'
import { toast } from 'react-toastify'
import { useQuery } from '@tanstack/react-query'
import EsimAPI from 'api/faber/EsimAPI'
import AbstractAuditLogDataGrid from 'common/AbstractAuditLogDataGrid'
import { generateColumnHeader } from 'helpers/column-generator/generateColumnHeader'
import { EsimReplacementLogType } from 'types/api/faber/customerAuditLog.type'
import { GetAllFaberUsersDetails } from 'types/api/faber/oneTimePack.type'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

function NewEsimReplacement({
  customerRow,
  faberToken,
  esimDialogOpen,
  expanded
}: NewEsimPropsType) {
  const [auditRows, setAuditRows] = useState<EsimReplacementLogType[]>([])

  const [page, setPage] = useState(0)
  const userId = 'userID' in customerRow ? customerRow.userID : customerRow._id
  const columns = useMemo(() => generateColumnHeader('esimReplacement'), [])
  const { isLoading: isEsimAuditLogsLoading, refetch: refetchEsimDataLogs } =
    useQuery(
      ['getEsimLogs', userId],
      async () => {
        const esimDataLogsRes = await EsimAPI.getEsimAuditLogs(
          userId,
          faberToken
        )
        return esimDataLogsRes.data
      },
      {
        enabled: expanded === 'panel3',
        onSuccess: (res) => {
          if (res.data === null) {
            setAuditRows([])
          } else {
            setAuditRows(res.data)
          }
        },
        onError: () => {
          setAuditRows([])
          toast.error('Error in retrieving audit logs for esim replacement ')
          return []
        }
      }
    )
  useEffect(() => {
    refetchEsimDataLogs()
  }, [esimDialogOpen])

  return (
    <>
      <AbstractAuditLogDataGrid
        loading={isEsimAuditLogsLoading}
        getRowId={(row: EsimReplacementLogType) => row._id}
        rows={auditRows}
        columns={columns}
        pagination
        page={page}
        onPageChange={(newPage) => setPage(newPage)}
        pageSize={5}
        tableHeight='250px'
      />
    </>
  )
}
export default NewEsimReplacement

interface NewEsimPropsType {
  customerRow: SubscriptionsTableRows | GetAllFaberUsersDetails
  faberToken: string
  esimDialogOpen?: boolean
  expanded: string | false
}
